import { get } from 'lodash';

const root = state => get(state, 'RecipeListingState.report');

export const getAllergens = state => get(root(state), 'allergens', []);

export const getLoading = state => get(root(state), 'loading', false);



// WEBPACK FOOTER //
// ./src/pages/recipelisting/state/report/selectors.js